import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { Col, Row, Input } from 'bootstrap';
import classnames from 'classnames';
import { fromJS } from 'immutable';
import PureRenderMixin from 'react-addons-pure-render-mixin';

export default React.createClass({
  displayName: 'EventCategorizedShowList',

  mixins: [PureRenderMixin],

  propTypes: {
    onEventClick: React.PropTypes.func,
    onShowClick: React.PropTypes.func,
    activeShow: React.PropTypes.object,
    events: React.PropTypes.array,
  },

  getInitialState() {
    return {
      searchTerm: '',
      searchedTagMatches: null,
      searchFocusState: false,
    };
  },

  render() {
    const { searchTerm, searchFocusState } = this.state;

    return (
      <div>
        <Row>
          <Col lg={24} md={24} sm={24}>
            <div className="search-container-header-input">
              <span
                className={classnames('search-wrapper', {
                  'has-focus': searchFocusState,
                })}
              >
                <Input
                  type="text"
                  placeholder="Search for show"
                  className={classnames('search-input', {
                    'has-value': searchTerm.length > 0,
                  })}
                  value={searchTerm}
                  addonBefore={<span>{this._getSearchPreControl()}</span>}
                  onChange={(e) => this._handleSearchChange(e.target.value)}
                  onFocus={() => this._toggleSearchInputFocus()}
                  onBlur={() => this._toggleSearchInputFocus()}
                />
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            className="event-show-menu__item-wrapper"
            lg={24}
            md={24}
            sm={24}
          >
            {this._getEventNodes()}
          </Col>
        </Row>
      </div>
    );
  },

  _getEventNodes() {
    const { searchedEventMatches } = this.state;
    const { events } = this.props;

    if (!events) return null;

    const eventList = searchedEventMatches || events;

    return eventList.map((event) => {
      return (
        <Row className="event-show-menu__item">
          <Col
            md={24}
            className="event-show-menu__item-event"
            onClick={() => this._handleEventSelection(event)}
          >
            <span>{event.get('title')}</span>
          </Col>
          <Col md={24} className="event-show-menu__item-shows">
            {this._getEventShowItems(event)}
          </Col>
        </Row>
      );
    });
  },

  _getEventShowItems(event) {
    return event.get('shows').map((show) => {
      return (
        <Row className="event-show-menu__item-show">
          <Col
            md={24}
            className="event-show-menu__item-show-title"
            onClick={() => this._handleShowSelection(event, show)}
          >
            <span>{show.get('title')}</span>
          </Col>
        </Row>
      );
    });
  },

  _handleShowSelection(event, show) {
    const { onShowClick } = this.props;
    onShowClick(event, show);
  },

  _handleEventSelection(event) {
    const { onEventClick } = this.props;
    onEventClick(event);
  },

  _toggleSearchInputFocus() {
    const { searchFocusState } = this.state;
    this.setState({ searchFocusState: !searchFocusState });
  },

  _getSearchPreControl() {
    const { searchTerm } = this.state;
    const hasValue = searchTerm.length < 1 ? false : true;

    const searchNode = (
      <span className="search-prefix-wrapper">
        <Icon name="search" />
      </span>
    );

    const removeNode = (
      <span
        onClick={() => this._clearSearchTerm()}
        className="search-prefix-wrapper remove"
      >
        <Icon name="times" />
      </span>
    );

    return hasValue ? removeNode : searchNode;
  },

  _clearSearchTerm() {
    this.setState({ searchTerm: '', searchedEventMatches: null });
  },

  _handleSearchChange(searchTerm) {
    const { events } = this.props;

    let jsEvents = events.toJS();

    let eventSearchRegex = new RegExp(searchTerm, 'ig');

    let eventMatches = [];

    jsEvents.forEach((event) => {
      let eventMatched = event.title.match(eventSearchRegex);
      let matchedShows = event.shows.filter((show) => {
        return show.title.match(eventSearchRegex);
      });

      if (eventMatched || matchedShows.length > 0) {
        event.shows = matchedShows;
        eventMatches.push(event);
      }
    });

    eventMatches = fromJS(eventMatches);

    if (searchTerm.length < 1) eventMatches = null;

    return this.setState({ searchTerm, searchedEventMatches: eventMatches });
  },
});
